import { Navigate, Route, Routes, Outlet } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import DocumentTitle from 'react-document-title'
import ProfilesList from './ProfilesList'

const profilesBreadcrumbs: Array<PageLink> = [
  {
    title: 'Profiles',
    path: '/profiles/',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const ProfilesPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='list'
          element={
            <>
              <DocumentTitle title={process.env.REACT_APP_NAME + ' | Profiles'}></DocumentTitle>
              <PageTitle breadcrumbs={profilesBreadcrumbs}>Profiles</PageTitle>
              <ProfilesList />
            </>
          }
        />
        <Route index element={<Navigate to='/profiles/list' />} />
      </Route>
    </Routes>
  )
}

export default ProfilesPage
